import React from 'react';

const CartTotals = (props) => {
  const { data } = props;
  const { items, item_count } = data;

  return (
    <ul className="minicart__totals">
      <li>
        <span className="label">Shipping</span>
        <span className="amount">Calculated at Checkout</span>
      </li>
      {data.total_discount > 0 && (
        <li>
          <span className="label">Discounts</span>
          <span className="discount amount">${(data.total_discount / 100).toFixed(2)}</span>
        </li>
      )}
      <li className="subtotal">
        <span className="label">Subtotal</span>
        <span className="total amount">${(data.total_price / 100).toFixed(2)}</span>
      </li>
    </ul>
  );
};

export default CartTotals;
